export const translationsES = {
    welcome: "¡Bienvenido a ArteOnU!",
    my_account_: "Mi Cuenta",
    interesed: 'También puede interesarte',
    relacioned: 'También te gustaría',
    view:{
      shop:"VER TIENDA",
      profile:"Editar",
      level:"Nivel",
      myprofile:{
        my_profile:"Mi Perfil",
        my_benefits:"Mi Beneficios",
        my_info:"Mis Datos",
        name: 'Nombre',
        lastname: 'Apellido',
        phone: 'Telefono',
        email: 'Correo eléctronico',
        membership_number:'Número de Fan',
        edit: 'Editar datos',
        edit_my_profile: 'Editar mis datos',
        log_out: 'Cerrar Sesión',
        store:'GUARDAR DATOS',
        category:'Nivel',
        generate_crystals:'51 a 150 Cristales',
        affiliation_number:'Número de Fan',
        success:"Datos actualizados correctamente",
        unsubscribe: "Darse de Baja aquí",
        unsubscribe_title: "¿Quieres darte de baja de Art(e)Fans?",
        unsubscribe_text: "<p>¡Te vamos a extrañar! Pero recuerda: Sé libre, sé feliz, sé tú mismo.</p><p>Envía un correo a <a href='mailto:info@arteonu.com'>info@arteonu.com</a> desde el mismo email con el que te suscribiste.</p><p><strong>Asunto:</strong> Quiero mi baja de Art(e) Fans. </p><p>Incluye tu nombre completo, número de socio y, si quieres, una breve razón de tu decisión.</p><p>Te enviaremos los términos de la baja.<br>Solo responde con:</p><ul style='text-align:center'><li>• 'Sí, procedan a la baja', o</li> <li>• 'No, quiero seguir'</li></ul><p><strong>¡Gracias por haber sido parte de Art(e) Fans!</strong></p>",
        unsubscribe_confirm: "Cerrar",
      },
      orders:{
        title:'Mis Pedidos',
        subtitle:'Rastrear paquetes, devolver pedidos o comprar algo de nuevo.',
        view:'VER MIS PEDIDOS',
        buynew:"Devoluciones o compar algo nuevamente.",
        view_item:"Ver articulo",
      },
      address:{
        title:'Mis direcciones',
        subtitle:'Direcciones guardadas para la entrega de tus compras.',
        edit:'Editar',
        add:'Agregar',
        address:'Dirección',
        edit_shipping:'Editar dirección de envío',
        add_shipping:'Agregar dirección de envío',
        street_numer_apt_1:'Línea de dirección 1',
        street_numer_apt_2:'Línea de dirección 2',
        postal_code:'Código Postal',
        city:'Ciudad/Estado',
        detail:'Detalles',
        adddetail:'Agrega detalles de la dirección',
        update: 'ACTUALIZAR DATOS',
        store:'GUARDAR DATOS',
        delete:'Eliminar esta dirección de envío'
      },
      loading:'cardango...',
    },
    login: {
      title: 'Iniciar Sesión',
      titleM: 'INICIAR SESION',
      registerM: 'REGISTRARSE',
      already_account:'¿Ya tienes una cuenta?',
      country: 'País',
      name: 'Nombre',
      lastname: 'Apellido',
      email: 'Email',
      date: 'Fecha de nacimiento',
      date_error:"Debes ser mayor de 18 años para registrarte.",
      password: 'Contraseña',
      submit: 'INICIAR SESIÓN',
      forgotPassword: '¿Olvidaste tu contraseña?',
      recoverPassword: 'Recuperar contraseña',
      google: 'Continuar con Google',
      facebook: 'Continuar con Facebook',
      wemail: 'Continuar con email',
      no_register:'¿Aun no estas registrado?',
      create:'Crear cuenta',
      password_no:'Contraseña incorrecta',
      forgout: '¿Olvidaste tu contraseña?',
      confirm_email:'Confirma tu correo electrónico',
      register_success:'Registro exitoso',
      phone:'Número móvil',
      term1:'Al hacer click en "Registrarse" aceptas nuestros',
      term2:'Términos y Condiciones',
      term3:'Términos de Uso',
      term4:'Términos de Servicio',
      term5:'Políticas de Privacidad',
      term6:'así como el',
      term7:'Aviso de Privacidad',
      nameplacesholder: 'Nombre oficial',
      lastnameplacesholder: 'Apellido oficial',
      error1:'Debe llenar todos los campos',
      error2:'Credenciales inválidas',
      error3:'Error en la autenticación de usuario',
      error4:'Debe introducir un correo',
      error5:'Error al enviar el correo de recuperación de clave',
      rollback:'Gacias por volver :D',
      resend:"Mensaje reenviado con éxito",
      check_spam:'Por favor, revisa tu carpeta de spam, por si acaso.',
    },
    recovery:{
      enter:'Ingresa el correo electrónico que utilizaste al registrarte para recuperar tu contraseña. Recibirás un enlace para restablecer tu contraseña',
      title:'Recuperar contraseña',
      titleM:'RECUPERAR CONTRASEÑA',
      change:'Cambiar contraseña',
    },
    shopping:{
      title:'Carrito de compra',
      discount_code:'Código de descuento',
      if_code:'Si cuentas con un código de descuento, ingrésalo aquí.',
      total_products:'Productos totales',
      subtotal:'Subtotal',
      discount:'Descuento',
      shipping:'Gastos de envio',
      purchased:'REALIZAR COMPRA',
      apply:'APLICAR',
    },
    product:{
      detail:'Detalle de producto',
      store:'GUARDAR',
      size:'Talla',
      color:'Color',
      delete:'Eliminar',
      edit:'Editar',
      quanty:'Cantidad',
      find_size:'Encuentra tu talla',
      size_description:'Las medidas de las tallas pueden variar según el producto. Te invitamos a revisar la siguiente información para que elijas la talla ideal para ti.',
      select_size:'Selecciona la talla',
      select_color:'Selecciona el color',
      important:'Importante',
      size_information:'Las medidas de las tallas pueden variar según el producto. Consulta la sección “Encuentra tu talla” y elige la que mejor se adapte a ti.',
      no_available:'Producto NO DISPONIBLE',
      add_cart:'AGREGAR AL CARRITO',
      buy:'COMPRAR AHORA',
      leet_me:'AVISARME CUANDO ESTE DISPONIBLE',
      will_send:'Te enviaremos un correo cuando este producto esté disponible.',
      no_stock:'Producto agotado',
      no_stock_layer:'Este producto está agotado. Puedes introducir tu email y te enviaremos un correo cuando el producto esté disponible de nuevo',
      discount:'REBAJA',
      link:"Enlace copiado",
      contact: "¿Tienes alguna duda o comentario sobre este producto SKU {{sku}}?",
      contact2: "Escríbenos a info@arteonu.com",
      mailto: "mailto:info@arteonu.com?subject=Consulta sobre producto SKU {{sku}}&body=Hola,%0D%0A%0D%0ATengo una pregunta sobre el producto SKU {{sku}}:%0D%0A%0D%0A[Por favor escribe tu duda o comentario aquí]%0D%0A%0D%0ASaludos,",
    },
    checkout:{
      init:'IR A HOME',
      guest_title:'Comprar como invitado',
      name:'Nombre',
      lastname:'Apellido',
      name_placeholder:'Ingresa tu nombre',
      name_placeholder: "Ingresa tu apellido",
      email:'Email',
      email_placeholder:'Ingresa tu email',
      login_button:'INICIAR SESIÓN',
      forgot_password:'¿Olvidaste tu contraseña?',
      recover_password:'Recuperar contraseña',
      not_registered:'¿Aún no estás registrado?',
      create_account:'Crear cuenta',
      address:'Dirección de envío',
      stored:'Mis direcciones',
      select:'Selecciona la dirección a donde enviaremos tu compra.',
      with_pay:'El cobro es standard shipping, si requieres otra forma de envío, por favor contáctanos.',
      add_address:'AGREGAR OTRA DIRECCION',
      edit_address:'Editar',
      continue:'CONTINUAR',
      indicated:'Indica la dirección a donde enviaremos tu compra.',
      information:'Información de pago',
      credicard:'Tarjeta de crédito o débito',
      card:'Tarjeta',
      paypal:'Tu pago se realizará desde tu cuenta de PayPal',
      success:'¡Compra exitosa!',
      error:'¡Compra fallida!',
      your_pay_success:'Tu pago fue realizado con éxito',
      your_pay_error:'Tu pago no pudo ser procesado',
      send1:'Hemos enviado un correo electrónico a: ',
      send2:'con los detalles de su compra',
      send_error:'Por favor contáctese con nosotros para resolver el problema.',
      check:'VER MIS PEDIDOS',
      continue_shopping:'SEGUIR COMPRANDO',
      success_pending:'¡Pago pendiente!',
      your_pay_pending:'Tu pedido ha sido procesado correctamente.',
      send1_pending:'Te hemos enviado un correo a: ',
      send2_pending:'con los detalles de tu orden.',
      register_benefits:'Continúa con tu registro para disfrutar de los beneficios de Art(e) Fans.',
      venmozelle:'RECIBIR INSTRUCCIONES DE PAGO',
      payzellevenmo:'Los pagos via Zelle or Venmo deben realizarse en USD. Quiere cambiar la moneda a USD?',
      payzellevenmo_btn:'SI',
      processing_payment: 'Estamos procesando tu pago',
      dont_close_window: 'Por favor no cierre la ventana',
      pay_now: "Pagar",
      check_spam: 'Por favor también revisa tu carpeta de spam, por si acaso.',
      error_fields: "Por favor, asegúrate de llenar todos los campos correctamente.",
      contact: "¿Tu país no aparece en la lista de envíos? Contáctanos para ayudarte con el envío.",
    },
    summary:{
      title:'Resumen del pedido',
      see:'Ver resúmen',
      gift:"Producto de regalo"
    },
    legal:{
      dudas:"¿Tienes dudas?",
      contact:"CONTÁCTANOS",
      description:"¡Ponte en contacto con nosotros!",
      category:"VER CATEGORÍAS",
    },
    footer:{
      term1:"Términos y Condiciones",
      term2:"Términos de Servicio",
      term3:"Términos de Privacidad",
      term4:"Cambios y Devoluciones",
      term5:"Tabla de Tallas",
      term6:"Envíos",
      term7:"Cookies",
      term8:"Todos los derechos reservados 2025",
      term9:"Información",
      term10:"Contáctanos",
    },
    home:{
      abouttext:'Quienes Somos',
      about:'A veces atravesar una crisis es un buen motivo para empezar algo positivo. Es así como la historia de Arte On U comenzó de la mano de su fundador y Director Artístico, Miguel Pérez Lem. En 2020....',
      about_button:'LEER MÁS',
      register: 'Registrarse',
      search: 'Buscar un producto',
      li1: "10% de descuento en tu primer pedido online.",
      li2:"Acumula puntos y obtén beneficios.",
      li3:"Ayuda con la compra con el diseñador.",
      li4:"Y más.",
      li5:"Porque toda Diva ama a sus fans — y no nos atreveríamos a olvidarnos de los nuestros. ",
      li6:"Art(e) Fans",
      li7: "no es solo un programa de recompensas, es tu pase de acceso total a la Casa de lo Fabulosos. Creamos este espacio para tu",
      li8: " “Glow-UP” ",
      li9: "definitivo. Para brillar. Para arrasar. Para ser glorioso, auténtico e innegablemente tú mismo.",
      contact:'Contáctanos',
    },  
    confirmation:{
      email:'Confirma tu correo',
      send1:'Hemos enviado un correo electrónico a: ',
      send2:'para confirmar tu cuenta.',
      send3:"Si no encuentras el mensaje en tu bandeja principal, revisa las bandejas de spam y promociones",
      send4:'¿No recibiste el correo de confirmación?',
      send5:"Reenviar correo",
      send6:"¿Olvidaste tu contraseña?",
      send7:"Recuperar contraseña",
      send8:'con un enlace para recuperar tu contraseña.',
      send9:'Si no encuentras el mensaje en tu bandeja principal, revisa las bandejas de spam y promociones.',
      send10:"¿No recibiste el correo de confirmación?",
      send11:"Reenviar correo",
      send12:"Enviar SMS",
      send13:"Volver al sitio",
      send14:"Ir"
    },
    collections:{
      send1:'Colecciones:',
      send2:'Todas',
      send3:'Vertical',
      send4:'Horizontal',
      send5:'¡No hemos encontrado nada!',
      send6:'No hemos encontrado nada relacionado con tu',
      send7:', intenta utilizar otros términos de búsqueda.',
      send8:'Subcategorías:',
    },
    benefits:{
      title:'Art(e)Fans Glow-Ups Rewards',
      redward:'VER MIS RECOMPENSAS',
      next:"Estas muy cerca de desbloquear el siguiente nivel",
      unlock:"¡Recompensas hechas para ti, según tu categoría!",
      redem:"Recompensa redimida",
      cristals:"Cristales",
      amber:{
        cristals:"51 a 150 Cristales",
        benefits_title_1:'Exclusividad, antes que nadie.',
        benefits_description_1:'Como miembro valioso de este exclusivo nivel, disfrutarás de acceso anticipado a nuestras nuevas colecciones, una semana antes del lanzamiento oficial. Con nuestras exclusivas ediciones limitadas, esta es tu invitación para conseguir las piezas que te identifican, antes de que nadie sepa que existen',
        benefits_title_2:"¡Feliz cumpleaños, cariño!",
        benefits_description_2:"En el día más emblemático del año, no solo celebramos tu nacimiento, sino que celebramos tu lado más amoroso, fabuloso y auténtico. Prepárate para una sorpresa, porque te mereces todo el amor, el brillo y todo lo extra que ese día te depare. ¡Sigue radiante, sigue siendo tú!",
        benefits_title_3:"Envíos gratis",
        benefits_description_3:"¿A quien no le gusta recibir los envíos sin cargo? Aunque están sujetos a nuestras políticas de envíos, tendrás un trato preferencial a la hora de ser enviados.",
        benefits_title_4:"Asesoría exclusiva",
        benefits_description_4:"Una vez al mes, disfruta de una charla íntima de 30 minutos con nuestro experto en diseño e imagen—ya sea por chat, llamada o videollamada. Es tu momento para soltar el chisme: desde lo escandaloso que fue tu fin de semana hasta tramar cómo conquistar a tu nuevo crush con uno de nuestros deslumbrantes diseños. Estamos aquí para eso. Trae el drama, trae el deseo—nosotros ponemos el estilo."  
      },
      emerald:{
        cristals:"151 a 300 Cristales",
        benefits_title_1:"Exclusividad, antes que nadie.",
        benefits_description_1:"Como miembro valioso de este exclusivo nivel, disfrutarás de acceso anticipado a nuestras nuevas colecciones, dos semanas antes del lanzamiento oficial. Con nuestras exclusivas ediciones limitadas, esta es tu invitación para conseguir las piezas que te identifican, antes de que nadie sepa que existen.",
        benefits_title_2:"¡Feliz cumpleaños, cariño!",
        benefits_description_2:"En el día más emblemático del año, no solo celebramos tu nacimiento, sino que celebramos tu lado más amoroso, fabuloso y auténtico. Prepárate para una sorpresa, porque te mereces todo el amor, el brillo y todo lo extra que ese día te depare. ¡Sigue radiante, sigue siendo tú!",
        benefits_title_3:"Envíos gratis",
        benefits_description_3:"¿A quien no le gusta recibir los envíos sin cargo? Aunque están sujetos a nuestras políticas de envíos, tendrás un trato preferencial a la hora de ser enviados.",
        benefits_title_4:"Asesoría exclusiva",
        benefits_description_4:"Una vez al mes, disfruta de una charla íntima de 30 minutos con nuestro experto en diseño e imagen—ya sea por chat, llamada o videollamada. Es tu momento para soltar el chisme: desde lo escandaloso que fue tu fin de semana hasta tramar cómo conquistar a tu nuevo crush con uno de nuestros deslumbrantes diseños. Estamos aquí para eso. Trae el drama, trae el deseo—nosotros ponemos el estilo.",
        benefits_title_5:"Segunda Asesoría Exclusiva",
        benefits_description_5:"¿La novela continúa? Tranquilo, my dear—nosotros te respaldamos. Vuelves para la segunda ronda y estamos listos para todo el chisme jugoso. Suelta el drama, desahógate, y vamos a seguir elevando ese estilo fabuloso que deja a todos boquiabiertos (¡especialmente a esas perras!). Porque lo fabuloso nunca descansa.",
        benefits_title_6:"Sorpresa de Temporada",
        benefits_description_6:"¡Nos encanta crear cosas especiales para alguien tan único como tú! Cada temporada te enviaremos un pequeño presente para darle un toque extra a tu estilo y mantenerte deslumbrante todo el año. ¡Te lo mereces, cariño!",
      },
      diamond:{
        cristals:"Desde 301 Cristales",
        benefits_title_1:"Exclusividad, antes que nadie.",
        benefits_description_1:"Como miembro valioso de este exclusivo nivel, disfrutarás de acceso anticipado a nuestras nuevas colecciones, tres semanas antes del lanzamiento oficial. Con nuestras exclusivas ediciones limitadas, esta es tu invitación para conseguir las piezas que te identifican, antes de que nadie sepa que existen.",
        benefits_title_2:"¡Feliz cumpleaños, cariño!",
        benefits_description_2:"En el día más emblemático del año, no solo celebramos tu nacimiento, sino que celebramos tu lado más amoroso, fabuloso y auténtico. Prepárate para una sorpresa, porque te mereces todo el amor, el brillo y todo lo extra que ese día te depare. ¡Sigue radiante, sigue siendo tú!",
        benefits_title_3:"Envíos gratis",
        benefits_description_3:"¿A quien no le gusta recibir los envíos sin cargo? Aunque están sujetos a nuestras políticas de envíos, tendrás un trato preferencial a la hora de ser enviados.",
        benefits_title_4:"Asesoría exclusiva",
        benefits_description_4:"Una vez al mes, disfruta de una charla íntima de 30 minutos con nuestro experto en diseño e imagen—ya sea por chat, llamada o videollamada. Es tu momento para soltar el chisme: desde lo escandaloso que fue tu fin de semana hasta tramar cómo conquistar a tu nuevo crush con uno de nuestros deslumbrantes diseños. Estamos aquí para eso. Trae el drama, trae el deseo—nosotros ponemos el estilo.",
        benefits_title_5:"Segunda Asesoría Exclusiva",
        benefits_description_5:"¿La novela continúa? Tranquilo, my dear—nosotros te respaldamos. Vuelves para la segunda ronda y estamos listos para todo el chisme jugoso. Suelta el drama, desahógate, y vamos a seguir elevando ese estilo fabuloso que deja a todos boquiabiertos (¡especialmente a esas perras!). Porque lo fabuloso nunca descansa.",
        benefits_title_6:"Sorpresa de Temporada",
        benefits_description_6:"¡Nos encanta crear cosas especiales para alguien tan único como tú! Cada temporada te enviaremos un pequeño presente para darle un toque extra a tu estilo y mantenerte deslumbrante todo el año. ¡Te lo mereces, cariño!",
        benefits_title_7:"A tu medida",
        benefits_description_7:"Eres único, ¿por qué tu ropa debería ser diferente? Nos complace ofrecerte un servicio de sastrería gratuito cada mes para que tus prendas te queden como a ti te gusta. Porque cuando algo está hecho para ti, debe sentirse así de especial. Ajuste perfecto. Sin costo adicional. Solo para ti.",
      }
    },
    form:{
      title:'CONTÁCTANOS',
      message:'Envíanos un mensaje',
      name:'Nombre',
      email:'Correo',
      msj:'Mensaje',
      send:'ENVIAR',
      follow:'¡Síguenos!',
      text1:'Formulario enviado con éxito',
      text2:'Gracias por contactarnos, nos comunicaremos contigo a la brevedad.',
      accep:'ACEPTAR',
    },
    cart:{
      title1:'Producto agregado',
      title2:'al carrito',
      title3:'Hay',
      title4:'artículos en tu carrito con un total de:',
      title5:'VER CARRITO',
      title6:'SEGUIR COMPRANDO',
      error1:"Introduzca un codigo válido",
      addcod:"Codigo introducido correctamente",
      error3:"Debe de tener items en el carrito para usar este codigo",
      error4:"Introduzca un codigo válido"
    },
    error:{
      size:"Debe de seleccionar una talla",
      quanty:"Añada una cantidad valida",
      address:"Debe seleccionar una dirección",
      address_continue:"Debes guardar la direccion antes de continuar",
      addressd:"Ocurrió un error al guardar la dirección",
      addresse:"Dirección guardada con éxito",
      addresde:"Direccion eliminada con éxito",
      addresmo:"No se puede eliminar la direccioón por los momentos",
      ar:"El campo de dirección es obligatorio",
      cp:"El código postal debe ser un número entero",
      city:"El campo de ciudad es obligatorio",
      field:"Faltan campos por llenar",
      geral:"Ocurrio un error, intente mas tarde",
      no_fa:"No se pudo agregar a favoritos",
      pass:"Las claves no coinciden",
      passe:"Error intentar cambiar clave",
      addressnoa:"Direccion no disponible",
      date_birth:"Debe de registrar su fecha de nacimiento para poder continuar"
    },
    orders:{
      id:"ID del pedido",
      realized:"Pedido realizado el",
      hide:"Ocultar Detalles",
      show:"Detalles",
      address:"Dirección de envío",
      status:"Estatus",
      track:"Rastrear el envío",
      policies:"Políticas de Cambio y Devolución",
      details:"Detalles del pedido",
      code:"Código de descuento",
      products:"Productos",
      shipping:"Envío",
      promotion:"Promoción aplicada",
      inorder:"Productos en el pedido"
    },
    wishlist:{
      articles:"articulos",
      list:"Favoritos",
      noavailable:"Lista de favoritos no disponible",
      noadd:"No se pudo agregar a favoritos",
    },
    categories:{
      our_artists:"Nuestros Artistas",
      our_artists_uri:"nuestros-artistas",
    },
    stripe:{
      error1:"Checkout no disponible, intentelo de nuevo",
      error2:"Stripe no disponible",
    }
};